
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClipboard as ObiClipboardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-clipboard.js';
 
 
 

 
 export const ObiClipboard = createComponent({
   react: React,
   tagName: 'obi-clipboard',
   elementClass: ObiClipboardElement,
   events: {
     
   }
  });
 
 